module.exports = __webpack_public_path__ + "28e21402914e1304bd8927624f65e09c.pdf";